(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bruun-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var drawer = document.querySelector('[data-bruun-cart-drawer]');
    if (!drawer || drawer.getAttribute('data-bruun-ready')) return;
    drawer.setAttribute('data-bruun-ready', 'true');

    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var sectionId = drawer.getAttribute('data-section-id');
    var lastFocus = null;

    function panel() { return drawer.querySelector('[data-bruun-cart-panel]'); }
    function updateHeaderCount(count) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-bruun-cart-count]'), function (el) { el.textContent = count; el.hidden = count === 0; });
    }
    function rerender() {
      return fetch(rootPath + '?section_id=' + sectionId, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-bruun-cart-drawer]');
          if (!fresh) return;
          var wasOpen = !drawer.hidden;
          drawer.innerHTML = fresh.innerHTML;
          drawer.setAttribute('data-count', fresh.getAttribute('data-count') || '0');
          updateHeaderCount(parseInt(fresh.getAttribute('data-count') || '0', 10));
          if (wasOpen) panel().focus();
        })
        .catch(function () {});
    }
    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.documentElement.classList.add('br-lock');
      var p = panel(); if (p) p.focus();
    }
    function close() {
      drawer.hidden = true;
      document.documentElement.classList.remove('br-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    drawer.open = function () { rerender().then(open); };
    drawer.close = close;

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-bruun-cart-close]')) { close(); return; }
      var btn = e.target.closest('[data-bruun-cart-qty]');
      if (btn) {
        var item = btn.closest('[data-bruun-cart-drawer] .br-cd__item');
        change(item.getAttribute('data-key'), parseInt(btn.getAttribute('data-bruun-cart-qty'), 10), item);
      }
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-bruun-cart-input]');
      if (!input) return;
      var item = input.closest('.br-cd__item');
      change(item.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0), item);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), input'));
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    function change(key, qty, item) {
      if (item) item.classList.add('is-busy');
      fetch(rootPath + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); return rerender(); })
        .catch(function () { if (item) item.classList.remove('is-busy'); });
    }

    /* Header cart button opens the drawer */
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-bruun-cart]');
      if (!link) return;
      e.preventDefault();
      drawer.open();
    });

    /* Any add-to-cart form on the page (product cards) adds without leaving the page */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (form.closest('[data-bruun-product]')) return; /* the product page handles its own */
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = drawer.getAttribute('data-label-adding') || '...'; }
      fetch(rootPath + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, credentials: 'same-origin', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); drawer.open(); })
        .catch(function () { if (btn) btn.textContent = drawer.getAttribute('data-label-failed') || '!'; })
        .then(function () { setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1200); });
    });

    /* Other scripts: cart:open opens it */
    document.addEventListener('cart:open', function () { drawer.open(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bruun-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (!root || root.getAttribute('data-bruun-ready')) return;
      root.setAttribute('data-bruun-ready', 'true');
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var sectionId = root.getAttribute('data-section-id');

      function rerender() {
        return fetch(window.location.pathname + '?section_id=' + sectionId, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-bruun-cart-page]');
            if (!fresh) return;
            root.innerHTML = fresh.innerHTML;
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(function () {});
      }
      function change(key, qty, item) {
        if (item) item.classList.add('is-busy');
        fetch(rootPath + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity: qty }) })
          .then(function (r) { return r.json(); })
          .then(rerender)
          .catch(function () { if (item) item.classList.remove('is-busy'); });
      }
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bruun-cart-qty]');
        if (!btn) return;
        var item = btn.closest('.br-cp__item');
        change(item.getAttribute('data-key'), parseInt(btn.getAttribute('data-bruun-cart-qty'), 10), item);
      });
      root.addEventListener('change', function (e) {
        var input = e.target.closest('[data-bruun-cart-input]');
        if (input) {
          var item = input.closest('.br-cp__item');
          change(item.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0), item);
          return;
        }
        var note = e.target.closest('[data-bruun-cart-note]');
        if (note) {
          fetch(rootPath + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ note: note.value }) }).catch(function () {});
        }
      });
    }
    function setupAll() { Array.prototype.forEach.call(document.querySelectorAll('[data-bruun-cart-page]'), setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAll); else setupAll();
    document.addEventListener('shopify:section:load', setupAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bruun-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(form) {
      if (!form || form.getAttribute('data-bruun-ready')) return;
      form.setAttribute('data-bruun-ready', 'true');

      var toggle = form.querySelector('[data-bruun-filter-toggle]');
      var panel = form.querySelector('[data-bruun-filter-panel]');
      if (toggle && panel) {
        toggle.addEventListener('click', function () {
          var open = panel.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      function submit() {
        /* leave empty price fields out of the address */
        Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (el) {
          if (el.value === '') el.disabled = true;
        });
        form.submit();
      }
      form.addEventListener('submit', function () {
        Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (el) {
          if (el.value === '') el.disabled = true;
        });
      });
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t.matches('input[type="checkbox"]') || t.matches('[data-bruun-sort]')) submit();
      });

      var drops = Array.prototype.slice.call(form.querySelectorAll('[data-bruun-filter]'));
      var desktop = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: true };
      drops.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open && desktop.matches) drops.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
      document.addEventListener('click', function (e) {
        if (!desktop.matches) return;
        drops.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
      });
      form.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        drops.forEach(function (d) {
          if (d.open) { d.open = false; var sum = d.querySelector('summary'); if (sum) sum.focus(); }
        });
      });
    }
    function setupAll() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-bruun-filters]'), setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAll); else setupAll();
    document.addEventListener('shopify:section:load', setupAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bruun-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (!root || root.getAttribute('data-bruun-ready')) return;
      root.setAttribute('data-bruun-ready', 'true');

      var menu = root.querySelector('[data-bruun-menu]');
      var openBtn = root.querySelector('[data-bruun-menu-open]');
      var closeBtn = root.querySelector('[data-bruun-menu-close]');

      function focusables() {
        return Array.prototype.slice.call(menu.querySelectorAll('a[href], button:not([disabled])'));
      }
      function openMenu() {
        menu.hidden = false;
        openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('br-lock');
        closeBtn.focus();
      }
      function closeMenu() {
        menu.hidden = true;
        openBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('br-lock');
        openBtn.focus();
      }
      if (menu && openBtn && closeBtn) {
        openBtn.addEventListener('click', openMenu);
        closeBtn.addEventListener('click', closeMenu);
        menu.addEventListener('keydown', function (e) {
          if (e.key !== 'Tab') return;
          var f = focusables();
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        });
        if (window.matchMedia) {
          var mq = window.matchMedia('(min-width: 990px)');
          var onChange = function (e) { if (e.matches && !menu.hidden) closeMenu(); };
          if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
        }
      }

      var drops = Array.prototype.slice.call(root.querySelectorAll('[data-bruun-drop]'));
      drops.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) drops.forEach(function (other) { if (other !== d) other.open = false; });
        });
      });
      document.addEventListener('click', function (e) {
        drops.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
      });
      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (menu && !menu.hidden) { closeMenu(); return; }
        drops.forEach(function (d) {
          if (d.open) { d.open = false; var sum = d.querySelector('summary'); if (sum) sum.focus(); }
        });
      });
    }

    function refreshCart() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          Array.prototype.forEach.call(document.querySelectorAll('[data-bruun-cart-count]'), function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
        })
        .catch(function () {});
    }

    /* Keep the counter right whatever cart script the theme uses: watch cart requests and common cart events. */
    if (!window.__bruunCartWatch) {
      window.__bruunCartWatch = true;
      var nativeFetch = window.fetch;
      if (nativeFetch) {
        window.fetch = function (input) {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var result = nativeFetch.apply(this, arguments);
          if (/\/cart\/(add|change|update|clear)/.test(url)) {
            result.then(function () { setTimeout(refreshCart, 200); }).catch(function () {});
          }
          return result;
        };
      }
      ['cart:refresh', 'cart:updated', 'cart:update', 'cart:change'].forEach(function (name) {
        document.addEventListener(name, refreshCart);
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
    }


    /* Predictive search: suggestions while typing, via Shopify's suggest endpoint */
    function setupSearch(wrap) {
      if (!wrap || wrap.getAttribute('data-bruun-ready')) return;
      wrap.setAttribute('data-bruun-ready', 'true');
      var input = wrap.querySelector('input[type="search"]');
      var box = wrap.querySelector('[data-bruun-suggest]');
      if (!input || !box) return;
      var timer = null, lastQuery = '', controller = null, active = -1;
      var labels = { products: wrap.getAttribute('data-label-products'), pages: wrap.getAttribute('data-label-pages'), collections: wrap.getAttribute('data-label-collections'), all: wrap.getAttribute('data-label-all'), none: wrap.getAttribute('data-label-none') };
      var fmt;
      try { fmt = new Intl.NumberFormat(wrap.getAttribute('data-locale') || 'nl', { style: 'currency', currency: wrap.getAttribute('data-currency') || 'EUR' }); } catch (e) { fmt = null; }
      function money(v) { var n = parseFloat(v); if (isNaN(n)) return ''; return fmt ? fmt.format(n) : n.toFixed(2); }
      function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
      function close() { box.hidden = true; box.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); active = -1; }
      function items() { return Array.prototype.slice.call(box.querySelectorAll('.br-suggest__item, .br-suggest__all')); }
      function highlight(i) {
        var list = items(); active = i;
        list.forEach(function (el, k) { el.classList.toggle('is-active', k === i); if (k === i) el.scrollIntoView({ block: 'nearest' }); });
      }
      function render(data, q) {
        var r = (data && data.resources && data.resources.results) || {};
        var products = r.products || [], pages = r.pages || [], collections = r.collections || [];
        var html = '';
        if (products.length) {
          html += '<div class="br-suggest__group">' + esc(labels.products) + '</div>';
          products.forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            var price = p.price ? money(p.price) : '';
            html += '<a class="br-suggest__item" role="option" href="' + esc(p.url) + '"><span class="br-suggest__img">' + (img ? '<img src="' + esc(img) + '&width=96" alt="" loading="lazy">' : '') + '</span><span class="br-suggest__text"><span class="br-suggest__title">' + esc(p.title) + '</span>' + (p.available === false ? '<span class="br-suggest__meta">&nbsp;</span>' : '') + '</span>' + (price ? '<span class="br-suggest__price">' + esc(price) + '</span>' : '') + '</a>';
          });
        }
        if (collections.length) {
          html += '<div class="br-suggest__group">' + esc(labels.collections) + '</div>';
          collections.forEach(function (c) { html += '<a class="br-suggest__item" role="option" href="' + esc(c.url) + '"><span class="br-suggest__text"><span class="br-suggest__title">' + esc(c.title) + '</span></span></a>'; });
        }
        if (pages.length) {
          html += '<div class="br-suggest__group">' + esc(labels.pages) + '</div>';
          pages.forEach(function (pg) { html += '<a class="br-suggest__item" role="option" href="' + esc(pg.url) + '"><span class="br-suggest__text"><span class="br-suggest__title">' + esc(pg.title) + '</span></span></a>'; });
        }
        if (!html) html = '<div class="br-suggest__none">' + esc(labels.none) + '</div>';
        html += '<a class="br-suggest__all" href="' + esc(wrap.getAttribute('data-search-url')) + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">' + esc(labels.all).replace('[query]', esc(q)) + '</a>';
        box.innerHTML = html; box.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1;
      }
      function search() {
        var q = input.value.trim();
        if (q.length < 1) { close(); return; }
        if (q === lastQuery && !box.hidden) return;
        lastQuery = q;
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        var url = wrap.getAttribute('data-root') + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
        fetch(url, { signal: controller ? controller.signal : undefined, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (data) { if (input.value.trim() === q) render(data, q); })
          .catch(function () {});
      }
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(search, 180); });
      input.addEventListener('focus', function () { if (input.value.trim() && box.innerHTML) box.hidden = false; });
      input.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        var list = items();
        if (e.key === 'ArrowDown') { e.preventDefault(); highlight(Math.min(active + 1, list.length - 1)); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(Math.max(active - 1, -1)); }
        else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); window.location.href = list[active].href; }
        else if (e.key === 'Escape') { close(); }
      });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    }

    function setupAll() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-bruun-header]'), setup);
      Array.prototype.forEach.call(document.querySelectorAll('[data-bruun-search]'), setupSearch);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAll); else setupAll();
    document.addEventListener('shopify:section:load', setupAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bruun-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var pop = document.querySelector('[data-bruun-popup]');
    if (!pop || pop.getAttribute('data-bruun-ready')) return;
    pop.setAttribute('data-bruun-ready', 'true');
    var key = pop.getAttribute('data-key');
    var days = parseInt(pop.getAttribute('data-days'), 10) || 30;
    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 8) * 1000;
    var box = pop.querySelector('[data-bruun-popup-box]');
    var isDone = /[?&]popup=done/.test(window.location.search) || /customer_posted=true/.test(window.location.search);
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    function seen() { try { var v = localStorage.getItem(key); return v && parseInt(v, 10) > Date.now(); } catch (e) { return false; } }
    function remember() { try { localStorage.setItem(key, String(Date.now() + days * 86400000)); } catch (e) {} }
    function open() { pop.hidden = false; document.documentElement.classList.add('br-lock'); if (box) box.focus(); }
    function close() { pop.hidden = true; document.documentElement.classList.remove('br-lock'); remember(); }

    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-bruun-popup-close]')) close();
      var copy = e.target.closest('[data-bruun-copy]');
      if (copy && navigator.clipboard) {
        navigator.clipboard.writeText(copy.getAttribute('data-bruun-copy')).then(function () {
          var small = copy.querySelector('small'); if (small) small.textContent = copy.getAttribute('data-label-copied');
        }).catch(function () {});
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    pop.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(pop.querySelectorAll('a[href], button:not([disabled]), input'));
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    if (isDone) { remember(); open(); return; }
    if (inEditor) { open(); return; }
    if (seen()) return;
    setTimeout(open, delay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bruun-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function load(el) {
      if (!el || el.getAttribute('data-bruun-ready')) return;
      el.setAttribute('data-bruun-ready', 'true');
      if (el.getAttribute('data-source') === 'recommendations') return;
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-bruun-related]');
          if (fresh && fresh.getAttribute('data-source') === 'recommendations' && fresh.querySelector('.br-pgrid')) {
            el.innerHTML = fresh.innerHTML;
            el.classList.remove('is-empty');
          }
        })
        .catch(function () {});
    }
    function loadAll() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-bruun-related]'), load);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadAll); else loadAll();
    document.addEventListener('shopify:section:load', loadAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
